import { supabase } from '../lib/supabaseClient.js';

export async function listInspectionReports() {
  const { data, error } = await supabase.from('inspection_reports')
    .select('*')
    .order('report_date', { ascending: false })
    .order('revision_no', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function listInspectionItems(reportIds) {
  if (!reportIds.length) return [];
  const { data, error } = await supabase.from('inspection_report_items')
    .select('*').in('report_id', reportIds).order('sort_order');
  if (error) throw error;
  return data || [];
}

export async function saveInspectionReport({ unitId, tenantId, reportType, reportDate, notes, items, previousReportId = null }) {
  const { data, error } = await supabase.rpc('save_inspection_report', {
    p_unit_id: unitId,
    p_tenant_id: tenantId,
    p_report_type: reportType,
    p_report_date: reportDate,
    p_notes: notes || null,
    p_items: items,
    p_previous_report_id: previousReportId
  });
  if (error) throw error;
  return { id: data };
}
